import st from "@/styles/LocationsPage.module.scss"
import DashboardWideComponent from "@/components/DashboardWideComponent.tsx";
import OfficeCard from "@/ui/OfficeCard.tsx";
import CMS from "@/utils/cms.ts";
import {useTranslation} from "react-i18next";
import {LocalLanguage} from "@/types_and_interfaces/types.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import DashboardClass from "@/utils/dashboard_class.ts";
import MapLayout from "@/components/MapLayout.tsx";
import MapMarkers from "@/pages/locations/elems/MapMarkers.tsx";
import LoadMapScript from "@/components/LoadMapScript.tsx";


const LocationsPage = () => {
    
    const offices = CMS.offices.offices
    const {t, i18n} = useTranslation()
    const [focus_office, set_focus_office] = useState<any>({})
    const navigate = useNavigate()
    const effectRan = useRef<boolean>(false)
    const [map_width, set_map_width] = useState(0)
    const ref = useRef<any>(null)
    
    const generateMapWidth = () => {
        let vw = window?.innerWidth
        
        
        if(vw && ref.current) {
            
            let container = ref.current
            
            if(vw >= 1800) {
                let cont_w = container.clientWidth
                set_map_width(vw - ((vw - cont_w) / 2 + 282))
            } else {
                set_map_width(vw - (350 + 264 + 20))
            }
        }
    }
    
    const setOfficeHandler = (off:any) => {
        if(window?.innerWidth >= CommonClass.breakpoints.breakpoint2) {
            set_focus_office(off)
        } else {
            if(effectRan.current === false) {
                navigate(DashboardClass.dashboard_routes.Office + "/" + CommonClass.convertLocationToId(off.coordonates))
                
                effectRan.current = true
            }
            
        }
    }
    
    const getOfficesTypes  = ():any => {
        if(!Array.isArray(offices) || (Array.isArray(offices) && !offices.length)) return {}
        let office_types:Array<any> = []
        let offices_with_types:Array<any> = []
        
        offices.map((off) => {
            const {central_office, secondary_office, intermediate_office} = off
            
            let off_statut = ""
            if(central_office) {
                off_statut = t("main_office")
            } else if (secondary_office) {
                off_statut = t("secondary_offices")
            } else if(intermediate_office){
                off_statut = t("intermediate_offices")
            }
            
            off.string_type = off_statut
            offices_with_types.push(off)
            
            if(office_types.find((x) => x === off_statut)) return
            office_types.push(off_statut)
        })
        
        return {
            office_types,
            offices_with_types
        }
    }

    const sorted_offices = getOfficesTypes()
    
    
    useEffect(() => {
        if(Array.isArray(offices) && offices.length) {
            
            generateMapWidth()
            
            window.addEventListener("resize", generateMapWidth)
            eventEmitter.on(CommonClass.CustomEvents.set_map_location, setOfficeHandler)
            
            let central =  offices.filter((o:any) => o.central_office)
            
            if(central.length) {
                let obj = CMS.langAwareFilter(central[0], (i18n.language as LocalLanguage))
                if(window?.innerWidth >= CommonClass.breakpoints.breakpoint2) {
                    eventEmitter.emit(CommonClass.CustomEvents.set_map_location, obj)
                }
            }
        
        }
        
        return () => {
            window.removeEventListener("resize", generateMapWidth)
            eventEmitter.off(CommonClass.CustomEvents.set_map_location, setOfficeHandler)
        }
    }, [offices]);
    
    useEffect(() => {
        const interval = setTimeout(() => {

            clearTimeout(interval)
            
        }, 1000)
    }, []);

    
    return Object.keys(sorted_offices).length ? (
        
        <DashboardWideComponent
            
            heading={t("offices")}
            
            onBackClick={() => {
                
                const prev = localStorage.getItem(CommonClass.local_storage_fields.prev_path)
                
                if(prev !== null) {
                    navigate(prev)
                } else {
                    navigate(-2)
                }
                
            }}
            
            
            column_center={
                
                <div ref={ref} className={st.column_center}>
                    
                    <div className={st.offices_box}>
                        
                        {sorted_offices?.office_types.length ? sorted_offices?.office_types.map((x:string, i:number) => {
                            
                            let offices_by_type = sorted_offices?.offices_with_types.filter((of:any) => of.string_type === x)
                            
                            return (
                                <div className={st.segment} key={"off_group"+i}>
                                    
                                    <strong>
                                        {x}
                                    </strong>
                                    
                                    <div className={st.offices}>
                                        {(Array.isArray(offices_by_type) && offices_by_type.length) ? offices_by_type.map((obj, j) => {
                                            const office_data = CMS.langAwareFilter(obj, (i18n.language as LocalLanguage))
                                            
                                            const is_selected = ():boolean => {
                                                if(!Object.keys(focus_office).length) return false
                                                
                                                if(focus_office.address === office_data.address && focus_office.city_name === office_data.city_name) {
                                                    return true
                                                }
                                                
                                                return false
                                            }
                                            
                                            return (
                                                <OfficeCard
                                                    key={"sorted_office"+i+j}
                                                    office={office_data}
                                                    onClick={() => {
                                                        eventEmitter.emit(CommonClass.CustomEvents.set_map_location, office_data)
                                                    }}
                                                    show_map_btn
                                                    selected={is_selected()}
                                                />
                                            )
                                        }) : null}
                                    </div>
                                
                                </div>
                            )
                        }) : null}
                    
                    </div>
                    
                    <div className={st.map_container}>
                        {/*{( window.google && window.google.maps) ? (*/}
                        
                        {/*    <MapLayout*/}
                        {/*        mapStyle={{*/}
                        {/*            width: `${map_width}px`,*/}
                        {/*            height: 'calc(100% + 24px)',*/}
                        {/*            zIndex: "0"*/}
                        {/*        }}*/}
                        {/*    >*/}
                        {/*        <MapMarkers />*/}
                        {/*    </MapLayout>*/}
                        {/*    */}
                        {/*) : (*/}
                            <LoadMapScript>
                                <MapLayout
                                    mapStyle={{
                                        width: `${map_width}px`,
                                        height: 'calc(100% + 24px)',
                                        zIndex: "0"
                                    }}
                                >
                                    <MapMarkers />
                                </MapLayout>
                            </LoadMapScript>
                        {/*)}*/}
                    </div>
                
                </div>
                
            }
        
        />
        
        
    ) : null
}



export default LocationsPage